<div class="sold-out-container card">
	<svg-inline
		class="section"
		[src]="'/assets/images/staking/staking.svg'"
		[alt]="'staking_logo_alternative_text' | translate" />
	<span class="sold-out-text">
		{{ "staking_sold_out_banner_text" | translate: [stakeableName] }}
	</span>
</div>
